const white: string = '#FFFFFF';
export default white;


